import React from "react";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col, Row, Modal } from "react-bootstrap";
import {
  deleteRequest,
  getRequest,
  postRequest,
} from "../../api/axiosRequests";
import { PALETTE } from "../../common/ThemeConstants";
import { BsCheckCircle } from "react-icons/bs";
import { Spinner } from "react-bootstrap";
import AlertModal from "../../common/components/AlertModal";

export default function SubscriptionForm({
  getCurrentSubscription,
  subscriptions,
  onHide,
  show,
  onSubmit,
}) {
  const [subscription, setSubscription] = useState({ id: -1 });
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [cover, setCover] = useState("");
  const [price, setPrice] = useState(0);
  const [months, setMonths] = useState(0);
  const [coverPreview, setCoverPreview] = useState("");
  const [isNew, setIsNew] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [loadedDelete, setLoadedDelete] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  const initForm = (data) => {
    if (data.id == -1) {
      setName("");
      setDescription("");
      setCover("");
      setCoverPreview("");
      setPrice(0);
      setMonths(0);
      setIsNew(true);
    } else {
      setName(data.name);
      setDescription(data.description);
      setCover(data.cover);
      setCoverPreview(data.cover);
      setPrice(data.price);
      setMonths(data.months);
      setIsNew(false);
    }
    setLoadedDelete(false);
    setLoaded(false);
    setIsLoading(false);
    setIsLoadingDelete(false);
  };

  const retrieveSubscription = () => {
    const data = getCurrentSubscription();
    setSubscription(data);
    initForm(data);
  };

  useEffect(() => {
    initForm(subscription);
  }, []);

  async function subscriptionPostRequest(data) {
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      Authorization: localStorage.getItem("jwt"),
      "Content-Type": "multipart/form-data",
      "X-CSRFToken": csrftoken,
    };
    const response = await postRequest("subscription/", data, headers);
    return response;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let formData = new FormData();
    const id = subscription.id ? subscription.id : "-1";
    formData.append("id", id);
    formData.append("name", name);
    formData.append("description", description);
    formData.append("cover", cover);
    formData.append("price", price);
    formData.append("months", months);
    subscriptionPostRequest(formData).then((result) => {
      onSubmit();
      setLoaded(true);
      setIsLoading(false);
      event.target.submit();
    });
  };

  const updateCover = (event) => {
    const selectedFile = event.target.files[0];
    setCover(selectedFile);
    const objectUrl = URL.createObjectURL(selectedFile);
    setCoverPreview(objectUrl);
  };

  async function deleteCallback(idSubscription) {
    setIsLoadingDelete(true);
    setShowDeleteForm(false);
    const headers = { Authorization: localStorage.getItem("jwt") };
    let response = deleteRequest("subscription/" + idSubscription, headers);
    response.then((result) => {
      onSubmit();
      setIsLoadingDelete(false);
      setLoadedDelete(true);
      onHide();
    });
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      onShow={retrieveSubscription}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {isNew && "New subscription"}
          {!isNew && "Update subscription"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertModal
          show={showDeleteForm}
          getDataId={() => {
            return subscription.id;
          }}
          onHide={() => {
            setShowDeleteForm(false);
          }}
          onCancel={() => {
            setShowDeleteForm(false);
          }}
          onConfirm={(id) => {
            deleteCallback(id);
          }}
          title={"Delete subscription"}
          description={"Are you sure you want to delete the subscription?"}
        />
        <Form
          className="p-2"
          onSubmit={handleSubmit}
          action="/private/adminSubscriptions"
        >
          <div
            style={{
              maxHeight: "300px",
              width: "100%",
              maxWidth: "100%",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            <div className="m-3">
              <Form.Group controlId="cover" className="mb-3">
                <Form.Label>Cover</Form.Label>
                <Row>
                  <Col xs={4}>
                    {coverPreview && (
                      <Form.Label>
                        <img src={coverPreview} width={75} alt={"Cover"} />
                      </Form.Label>
                    )}
                    {!coverPreview && (
                      <Form.Label style={{ color: PALETTE.GRAY }}>
                        Not found
                      </Form.Label>
                    )}
                  </Col>
                  <Col xs={8} className="align-self-center text-center">
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={updateCover}
                    />
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="name"
                  value={name}
                  onChange={(event) => {
                    setName(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="description"
                  value={description}
                  onChange={(event) => {
                    setDescription(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Price</Form.Label>
                <Form.Control
                  type="number"
                  autoComplete="price"
                  value={price}
                  onChange={(event) => {
                    setPrice(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{"Month(s)"}</Form.Label>
                <Form.Control
                  type="number"
                  autoComplete="months"
                  value={months}
                  onChange={(event) => {
                    setMonths(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
            </div>
          </div>
          <br />
          <Button
            style={{ width: "100%" }}
            variant="dark"
            type="submit"
            disabled={isLoading || loaded}
          >
            {isLoading && <Spinner animation="border" />}
            {!isLoading && !loaded && "Save"}
            {!isLoading && loaded && <BsCheckCircle size={30} />}
          </Button>
          {subscription.id !== -1 && (
            <div className="mt-2">
              <Button
                style={{ width: "100%" }}
                variant="danger"
                disabled={isLoadingDelete || loadedDelete}
                onClick={() => {
                  setShowDeleteForm(true);
                }}
              >
                {isLoadingDelete && <Spinner animation="border" />}
                {!isLoadingDelete && !loadedDelete && "Delete"}
                {!isLoadingDelete && loadedDelete && (
                  <BsCheckCircle size={30} />
                )}
              </Button>
            </div>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
}
